
import Login from '../pages/auth/login/login';
import ForgotPassword from '../pages/auth/forgot-password/forgot-password';
import ParentForm from '../pages/parent-form/parent-form';
import RoutesConstant from './routes';


const publicRoutes = [
  {
    id: 'login',
    path: RoutesConstant.LOGIN,
    component: Login,
    title: 'Login',
  },
  {
    id: 'forgot-password',
    path: RoutesConstant.FORGOT_PASSWORD,
    component: ForgotPassword,
    title: 'Forgot Password',
  },
   {
    id: 'parent-form-admin',
    path: `${RoutesConstant.PARENTFORM}/:institutionId`,
    component: ParentForm,
    title: 'Parent Form',
  }
];

export default publicRoutes;
